var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 20,
    viewBox: "0 0 4 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99935 12.668C1.62157 12.668 1.3049 12.5402 1.04935 12.2846C0.793793 12.0291 0.666016 11.7124 0.666016 11.3346V2.0013C0.666016 1.62352 0.793793 1.30686 1.04935 1.0513C1.3049 0.795747 1.62157 0.667969 1.99935 0.667969C2.37713 0.667969 2.69379 0.795747 2.94935 1.0513C3.2049 1.30686 3.33268 1.62352 3.33268 2.0013V11.3346C3.33268 11.7124 3.2049 12.0291 2.94935 12.2846C2.69379 12.5402 2.37713 12.668 1.99935 12.668ZM1.99935 19.3346C1.62157 19.3346 1.3049 19.2069 1.04935 18.9513C0.793793 18.6957 0.666016 18.3791 0.666016 18.0013C0.666016 17.6235 0.793793 17.3069 1.04935 17.0513C1.3049 16.7957 1.62157 16.668 1.99935 16.668C2.37713 16.668 2.69379 16.7957 2.94935 17.0513C3.2049 17.3069 3.33268 17.6235 3.33268 18.0013C3.33268 18.3791 3.2049 18.6957 2.94935 18.9513C2.69379 19.2069 2.37713 19.3346 1.99935 19.3346Z",
    fill: "#FE9706",
    stroke: "#FE9706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.149115a385dbd54e529801b534949551.svg";
export { ForwardRef as ReactComponent };